<template>
  <div class="ptos">
    <page-heading title="PTOs"></page-heading>

    <content-placeholder v-if="fetching">
      <el-card>
        <p class="text text-10 text-h-20"></p>
        <p class="text text-full"></p>
        <p class="text text-full"></p>
        <p class="text text-50"></p>
        <p class="text text-25"></p>
      </el-card>
    </content-placeholder>

    <div v-else>
      <el-card>
        <div slot="header">
          <span>Pending PTOs</span>
        </div>
        <div slot="footer">
          Total: {{ pendingPtos.length }}
        </div>
        <ptos-list :ptos="pendingPtos"></ptos-list>
      </el-card>
      <el-card v-if="fetchingAll">
        <p class="text text-10 text-h-20"></p>
        <p class="text text-full"></p>
        <p class="text text-full"></p>
        <p class="text text-50"></p>
        <p class="text text-25"></p>
      </el-card>
      <el-card v-else>
        <el-tabs v-model="activeName">
          <div class="between">
            <el-input type="text" v-model.lazy="filter" class="ptos_name_search" :placeholder="$t('modules.ptoAvailability.fields.search.placeholder')"></el-input>
            <el-date-picker type="year" class="yearPicker" v-model.lazy.trim="year"  format="yyyy" :picker-options="{format:'yyyy'}" :placeholder="$t('modules.ptoAvailability.fields.search.year')"></el-date-picker>
          </div>
          <el-tab-pane :label="`Rejected PTOs`" name="second">
            <el-card>
              <div slot="header">
                <span>Rejected PTOs</span>
              </div>
              <div slot="footer">
                Total: {{ rejectedPtos.length }}
              </div>
              <ptos-list :ptos="rejectedPtos"></ptos-list>
            </el-card>
          </el-tab-pane>
          <el-tab-pane :label="`Approved PTOs`" name="third">
            <el-card>
              <div slot="header">
                <span>Approved PTOs</span>
              </div>
              <div slot="footer">
                Total: {{ approvedPtos.length }}
              </div>
              <ptos-list :ptos="approvedPtos"></ptos-list>
            </el-card>
          </el-tab-pane>
        </el-tabs>
      </el-card>
      <pto-form-modal />
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';

  import PtosList from '@/components/pto/PtosList';
  import PtoFormModal from '@/components/pto/PtoFormModal';

  export default {
    name: 'PtosPage',
    components: {
      ptoFormModal: PtoFormModal,
      ptosList: PtosList,
    },
    data() {
      return {
        activeName: 'third',
        translationPrefix: 'pages.ptoRequests',
        filter: '',
        year: '',
        pendingPtos: [],
        fetchingAll: true,
      };
    },
    created() {
      this.fetchPendingPtos();
      this.fetchAllPtos();
    },
    watch: {
      activeName() {
        this.filter = '';
        this.year = '';
      },
    },

    computed: {
      ...mapGetters('entities/ptos', ['fetching']),
      ...mapGetters('entities/users', ['currentUser']),

      rejectedPtos() {
        let result = this.$store.getters['entities/ptos/query']()
          .with('user.profile')
          .with('category')
          .where('status', 'rejected')
          .get();
        if (this.filter.length > 0) {
          result = result.filter(data => data.user.profile.full_name.toLowerCase().includes(this.filter.toLowerCase()));
        }
        const year = new Date(this.year).getFullYear();
        if (year && year !== 1970) {
          result = result.filter(data => new Date(data.created_at).getFullYear() === year);
        }
        return result;
      },

      approvedPtos() {
        let result = this.$store.getters['entities/ptos/query']()
          .with('user.profile')
          .with('category')
          .where('status', 'approved')
          .get();
        if (this.filter.length > 0) {
          result = result.filter(data => data.user.profile.full_name.toLowerCase().includes(this.filter.toLowerCase()));
        }
        const year = new Date(this.year).getFullYear();
        if (year && year !== 1970) {
          result = result.filter(data => new Date(data.created_at).getFullYear() === year);
        }
        return result;
      },
    },
    methods: {
      ...mapActions('entities/ptos', ['fetchPtos', 'openFormModal']),
      fetchAllPtos() {
        this.fetchPtos().then(() => {
          this.fetchingAll = false;
        });
      },
      fetchPendingPtos() {
        this.$store.dispatch('entities/ptos/fetchPendingPtos', {})
          .then((response) => {
            if (response.status) {
              this.pendingPtos = response.data.entities;
            }
          });
      },
    },
  };
</script>

<style lang="scss">
  .el-tabs__content{
    overflow: visible;
  }

  .ptos_name_search {
    max-width: 300px;
    width: 300px;
    margin-right: 10px;
  }

  .between{
    display: flex;
    justify-content: left;
    align-items: center;
    margin-bottom: 10px;
  }

  .yearPicker{
    width: auto !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Ptos.vue